import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/components/theme-provider';
import { useTranslation } from 'react-i18next';

interface ModeToggleProps {
  className?: string;
}

export function ModeToggle({ className }: ModeToggleProps) {
  const { resolved, toggle } = useTheme();
  const { t } = useTranslation('common');
  const isDark = resolved === 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t(isDark ? 'accessibility.lightTheme' : 'accessibility.darkTheme')}
      aria-pressed={isDark}
      className={className ?? 'inline-flex items-center justify-center w-9 h-9 rounded-md border border-border bg-card hover:bg-muted transition-colors text-foreground'}
    >
      <Sun className={`w-4 h-4 ${isDark ? 'hidden' : 'block'}`} aria-hidden="true" />
      <Moon className={`w-4 h-4 ${isDark ? 'block' : 'hidden'}`} aria-hidden="true" />
    </button>
  );
}
